export default "__VITE_PUBLIC_ASSET__ab7e933c__"